module.exports = __webpack_public_path__ + "1553d9fa9140fc23570425c88919aba2.png";